import { resourceFactory } from '~/src/dash/api/resource';
import { getApiDomain } from '~/src/dash/resellers/utils/importResellerConfig';

export const headers = {
  'Content-Type': 'application/x-www-form-urlencoded',
};

export const apiFactory = resourceFactory(
  `${getApiDomain()}/v1/:core_section/:core_action/:action_id`,
);
export const apiFactory2 = resourceFactory(
  `${getApiDomain()}/v2/:core_section/:core_action/:action_id`,
);
